import React from 'react';
import './datepicker.scss';
import 'react-datepicker/dist/react-datepicker.css';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { DATEPICKER_FORMAT } from 'constants/date-format';
import enGb from 'date-fns/locale/en-GB';
import fi from 'date-fns/locale/fi';
import sv from 'date-fns/locale/sv';
import de from 'date-fns/locale/de';
import ReactDatePicker, { registerLocale } from 'react-datepicker';
import { useTranslate } from 'hooks/translate';

interface DatePickerProps {
  label?: string;
  error?: boolean;
  name: string;
  max?: Date | null;
  min?: Date | null;
  control: Control<PassengerDeclarationValues>;
  onChange?: (args: any[]) => any;
  setValue?: UseFormSetValue<PassengerDeclarationValues>;
  dateFormat?: string;
  placeholder?: string;
}

registerLocale('en', enGb);
registerLocale('fi', fi);
registerLocale('sv', sv);
registerLocale('de', de);

export default function DatePicker({
  label,
  name,
  error,
  min,
  max,
  control,
  dateFormat = DATEPICKER_FORMAT,
  placeholder = DATEPICKER_FORMAT.toUpperCase(),
}: DatePickerProps): React.ReactElement {
  const { locale } = useTranslate();

  return (
    <div className='datepicker-container'>
      <div className={`datepicker-input ${error ? 'error' : ''}`}>
        {label && <label htmlFor={name}>{label}</label>}
        <Controller
          control={control}
          name={name as any}
          render={({ field: { onChange, value, onBlur } }) => (
            <ReactDatePicker
              dateFormat={dateFormat}
              placeholderText={placeholder}
              locale={locale}
              onBlur={onBlur}
              onChange={(date: Date) => onChange(date)}
              selected={value}
              scrollableYearDropdown
              yearDropdownItemNumber={80}
              showYearDropdown
              showMonthDropdown
              maxDate={max}
              minDate={min}
            />
          )}
        />
      </div>
    </div>
  );
}
